import React from "react";
import styles from "./dialog.module.scss";
import {
  Alert,
  Button,
  CloseIcon,
  HeadingContainer,
  Illustration,
  List,
} from "@gataca/design-system/web";
import { gaColors } from "../../../assets/globalConstants";
import ScrollableList from "../../molecules/lists/ScrollableList/scrollableList";
import { DialogProps } from "../../../types/interfaces";
import cx from "classnames";

const Dialog = (props: React.PropsWithChildren<DialogProps>) => {
  // Props
  const {
    id,
    use,
    title,
    contentText,
    alert,
    status,
    primaryButton,
    secondaryButton,
    list,
    closableByBg,
    onClose,
  } = props;

  // Styles
  return (
    <>
      <div
        id={id}
        className={styles.bg}
        onClick={() => (closableByBg && onClose ? onClose() : undefined)}></div>
      <div className={styles.dialog}>
        {/* Top container */}
        <div
          className={cx(
            styles.topContainer,
            use === "actionable" && styles.borderBottom
          )}>
          {use === "actionable" ? (
            <HeadingContainer
              size={"small"}
              contentTextColor={"grey"}
              titleText={title}
            />
          ) : null}
          {onClose ? (
            <div className={styles.closeButton} onClick={onClose}>
              <CloseIcon size="24" color={gaColors.neutral1000} />
            </div>
          ) : null}
        </div>

        {/* Content */}
        <div className={styles.mainContainer}>
          <div
            className={cx(
              styles.statusTextImageContainer,
              use === "status" && styles.contentCentered
            )}>
            {/* Texts */}
            {use === "status" && status ? (
              <Illustration
                size={80}
                imgName={
                  status === "warning" ? "warningYellow" : status || "success"
                }
              />
            ) : null}
            {!!title?.length || !!contentText?.length ? (
              <div
                className={cx(
                  use === "status"
                    ? styles.statusPadding
                    : !(list && list?.list?.length) && !alert
                    ? "paddingBottom16"
                    : "paddingBottom0",

                  styles.textsContainer
                )}>
                <HeadingContainer
                  size={"small"}
                  contentTextColor={"grey"}
                  align={use === "status" ? "center" : "left"}
                  titleText={use === "status" ? title : undefined}
                  contentText={contentText}
                  className={cx(use === "status" ? styles.contentCentered : "")}
                />
              </div>
            ) : null}
          </div>
          {(list && list?.list?.length) || alert ? (
            <ScrollableList className={styles.scrollableArea}>
              {list && list?.list?.length ? (
                <List
                  {...list}
                  nestedScrollEnabled={true}
                  scrollEnabled={false}
                  containerStyle={{
                    flexShrink: 0,
                  }}
                />
              ) : null}
              {alert ? (
                <Alert {...alert} containerStyle={{ marginBottom: 16 }} />
              ) : null}
            </ScrollableList>
          ) : null}
        </div>

        {/* Bottom container */}
        {primaryButton || secondaryButton ? (
          <div className={styles.bottomContainer}>
            <div className={styles.buttonsContainer}>
              {secondaryButton ? (
                <Button
                  style={"outline"}
                  color={"purple"}
                  {...secondaryButton}
                  className={cx(
                    "paddingRight24 paddingLeft24 paddingTop12 paddingBottom12"
                  )}
                />
              ) : null}
              {primaryButton ? (
                <Button
                  style={"fill"}
                  color={"purple"}
                  containerStyle={{ borderWidth: 0 }}
                  {...primaryButton}
                />
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default Dialog;
